export class PaymentMethodRequestDto {
  merchantId?: number;
  merchantGroupId?: number;
  localStorageApiKey?: string;
  publicUrl?: string;
}
